<div class="flex-column h-100">
  <div class="configuration-wizard-header flex-column">
    <h5
      class="odx-title-5"
      i18n="@@gasWarningCenterConfiguration.selectLidtUnits.header"
      data-testid="gasWarningCenterConfiguration.selectLidtUnits.header"
    >
      Deckeleinheiten auswählen
    </h5>
    <app-filter-product (searchEvent)="search($event)"></app-filter-product>
    <div class="required-count-message">
      @if (lidUnitSelectionValid()) {
        <odx-inline-message variant="default">
          <ng-container i18n="@@lidUnits.required.count">Anzahl auszuwählender Deckeleinheiten:</ng-container>
          {{ requiredLidUnitQuantity() }}
        </odx-inline-message>
      } @else {
        <odx-inline-message variant="danger">
          <ng-container i18n="@@lidUnits.required.count">Anzahl auszuwählender Deckeleinheiten:</ng-container>
          {{ requiredLidUnitQuantity() }}
        </odx-inline-message>
      }
    </div>
  </div>

  <odx-content-box class="flex-column flex-scroll" odxLayout="flex">
    <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 mb-36 cards-container">
      @for (lidUnit of filteredLidUnits(); track lidUnit) {
        <app-product-card-with-quantity
          class="overflow-hidden"
          [productData]="lidUnit"
          [showCosts]="showCosts()"
          [imageUrl]="getLidUnitImageUrl(lidUnit)"
          [fallbackImageUrl]="fallbackImageUrl()"
          [selectionMode]="selectionMode"
          [quantity]="getSelectedLidUnitQuantity(lidUnit)"
          (quantityChanged$)="onLidUnitSelectionChange($event, lidUnit)"
        >
          @if (lidUnit.id) {
            <div class="feature">
              <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
              <p class="odx-text--small">{{ lidUnit.id }}</p>
            </div>
          }
        </app-product-card-with-quantity>
      }
    </div>
    @if (filteredLidUnits().length === 0) {
      <app-refresh-products-hint dataType="Deckeleinheiten" i18n-dataType="@@global.lidUnits"></app-refresh-products-hint>
    }
  </odx-content-box>
</div>
